var taroApp = taroApp || {};

taroApp = {
	initForm: function () {
		"use strict";

		this.buttonState(jQuery);

	},
	buttonState: function ($) {
		"use strict";

		var $form = $('#js-form__required');
		var $input = $form.find('input,textarea');
		var $required = $('.js-required');

		var $requiredEle = $required.find('input,textarea').not('[type="hidden"],[type="checkbox"]');
		var len = $requiredEle.length;
		var $checkbox = $required.find('[type="checkbox"]');
		var checkboxLen = $checkbox.length;

		var $submit = $('#contact-form__submit');
		var disabledClassName = 'contact-form__submit--is-disabled';

		var email = $('.js-email-check').find('input');
		var emailLen = email.length;

		var enteredClass = 'contact-form--entered';
		var validClass = 'contact-form--has-valid';
		var invalidClass = 'contact-form--has-invalid';

		function formCheck() {
			var error = [];
			var firstEmailInputIndex = false;
			for (var i = 0; i < len; i++) {
				// ckeck if entered once at first
				if ($requiredEle.eq(i).val() !== '') {
					$requiredEle.eq(i).parent().addClass(enteredClass);
				}

				var $ele = $requiredEle.eq(i);
				var val = $ele.val();
				var minLength = parseInt($ele.attr('minlength'));
				var maxLength = parseInt($ele.attr('maxlength'));
				var minValue = parseInt($ele.attr('min'));
				var maxValue = parseInt($ele.attr('max'));
				var isEmail = $ele.attr('type') === 'email';
				var isValidEmail = val.match(/.+@.+\..+/) !== null;

				// Tarosky specific
				if (emailLen > 1 && isEmail) {
					if (firstEmailInputIndex === false) {
						firstEmailInputIndex = i;
					} else {
						// 2個目のメールフォームをバリデートしている
						var email1 = $requiredEle.eq(firstEmailInputIndex).val();
						var email2 = $requiredEle.eq(i).val();
						isValidEmail = isValidEmail && (email1 === email2);
					}
				}

				if (
					val === '' ||
					(!isNaN(minLength) && minLength > val.length) ||
					(!isNaN(maxLength) && maxLength < val.length) ||
					(!isNaN(minValue) && !isNaN(val) && minValue > parseInt(val)) ||
					(!isNaN(maxValue) && !isNaN(val) && maxValue < parseInt(val)) ||
					(isEmail && !isValidEmail)
				) {
					error += i;
					$ele.parent().addClass(invalidClass);
					$ele.parent().removeClass(validClass);
				} else {
					$ele.parent().addClass(validClass);
					$ele.parent().removeClass(invalidClass);
				}
			}

			for (var j = 0; j < checkboxLen; j++) {
				if (!$checkbox.eq(0).is(':checked')) {
					error += j;
				}
			}

			if (error.length === 0) {
				$submit.removeClass(disabledClassName)
					.children().removeAttr("disabled");
			} else {
				$submit.addClass(disabledClassName)
					.children().attr("disabled", "disabled");
			}
		}

		$input.on('blur change', function () {
			formCheck();
		});

		formCheck();

	}
};
taroApp.initForm();
